/**
 * Test Routes Utility
 *
 * Helper functions for generating test route configurations for React Router.
 * Test routes are only included in development/local environments.
 */

import Authenticated from '#client/App/Authenticated';
import PostRouting from '#client/App/PostRouting';
import BUILD_ENV from '#client/build-env';
import { TEST_ROUTES } from '#client/config/testRoutes';
import * as Pages from '#client/pages';

/**
 * Check if test routes should be enabled
 * Test routes are enabled in development or local environments only
 * @returns {boolean}
 */
export function areTestRoutesEnabled() {
  return BUILD_ENV.IS_DEV || BUILD_ENV.IS_LOCAL;
}

/**
 * Generate React Router route objects for all test pages
 * Returns empty array if test routes are disabled
 * @returns {Array<import('react-router-dom').RouteObject>}
 */
export function generateTestRoutes() {
  if (!areTestRoutesEnabled()) {
    return [];
  }

  return TEST_ROUTES.map((testRoute) => {
    const Component = Pages[testRoute.componentName];

    if (!Component) {
      console.warn(
        `[TestRoutes] Component "${testRoute.componentName}" not found in Pages export. ` +
          `Make sure it's exported from src/pages/index.js`
      );
      return null;
    }

    return {
      path: testRoute.path,
      element: (
        <Authenticated optional>
          <PostRouting />
        </Authenticated>
      ),
      children: [
        {
          index: true,
          element: <Component />
        }
      ]
    };
  }).filter(Boolean);
}
